import * as api from 'api/supporters'

export const INTEGRATE_SUPPORTER_ACCOUNTS = 'INTEGRATE_SUPPORTER_ACCOUNTS'

export const integrateSupporterAccounts = ({ userId, plaidPublicToken, plaidInstitutionId, plaidAccountIdForWithdrawalAccount}) => ({
  type: INTEGRATE_SUPPORTER_ACCOUNTS,
  payload: api.integrateSupporterAccounts({ userId, plaidPublicToken, plaidInstitutionId, plaidAccountIdForWithdrawalAccount }),
})
